/* ==========================================================================
   Quiz Recommandation — Museau & Co
   Phase 1: Nouvel ordre, inputs âge/poids, traitement conditionnel
   ========================================================================== */

(function () {
  'use strict';

  /* ========== STEPS ========== */

  const BASE_STEPS = [
    'pet_type', 'pet_name', 'pet_breed', 'pet_age', 'pet_weight',
    'activity_level', 'medical_treatment'
  ];

  function getActiveSteps() {
    let steps = [...BASE_STEPS];
    
    // Si chat, on skip l'étape poids (posologie toujours la même)
    if (state.answers.pet_type === 'cat') {
      steps = steps.filter(s => s !== 'pet_weight');
    }
    
    // health_conditions est maintenant intégré dans medical_treatment
    steps.push('main_concern', 'symptoms', 'duration', 'save_profile');
    return steps;
  }

  /* ========== DATA ========== */

  // Fonction pour générer les labels d'activité avec le nom de l'animal
  function getActivityLabel(level, petName) {
    const name = petName || 'Votre compagnon';
    const labels = {
      low: `${name}, champion(ne) de la sieste`,
      moderate: `${name} aime ses petites balades quotidiennes`,
      high: `${name} est toujours partant pour jouer et courir`,
      extreme: `${name} ne s'arrête (presque) jamais`
    };
    return labels[level] || '';
  }

  const VET_TIPS = {
    joints: 'Les problèmes articulaires touchent 1 chien sur 5. Une prise en charge précoce avec les bons compléments peut vraiment améliorer la mobilité et le confort de {name}.',
    digestion: 'Un transit perturbé peut avoir de nombreuses causes. Les probiotiques naturels aident à rééquilibrer la flore intestinale de {name}.',
    skin: 'Les démangeaisons et problèmes de peau sont souvent liés à l\'alimentation ou à des carences. Un apport en omégas peut faire une vraie différence pour {name}.',
    immunity: 'Le système immunitaire de {name} peut être renforcé naturellement. C\'est particulièrement important pour les animaux seniors ou en convalescence.',
    stress: 'L\'anxiété chez nos compagnons est plus fréquente qu\'on ne le pense. Des solutions naturelles existent pour apaiser {name} sans effets secondaires.',
    dental: 'L\'hygiène dentaire est souvent négligée, pourtant 80% des chiens de plus de 3 ans ont des problèmes bucco-dentaires. La prévention est essentielle.',
    urinary: 'Les problèmes urinaires peuvent être prévenus avec une bonne hydratation et des compléments adaptés pour soutenir la fonction rénale de {name}.',
    parasites: 'Une protection naturelle contre les parasites complète efficacement les traitements antiparasitaires classiques.',
    prevention: 'La prévention est la clé d\'une bonne santé. Un apport régulier en nutriments essentiels aide {name} à rester en pleine forme.',
    vision: 'La santé oculaire de {name} mérite une attention particulière, surtout avec l\'âge. Des compléments adaptés peuvent aider à préserver sa vue.'
  };

  // Races de chiens populaires en France
  const DOG_BREEDS = [
    'Berger Allemand', 'Berger Australien', 'Berger Belge Malinois', 'Berger Blanc Suisse',
    'Golden Retriever', 'Labrador Retriever', 'Bouledogue Français', 'Bouledogue Anglais',
    'Cavalier King Charles', 'Chihuahua', 'Cocker Anglais', 'Cocker Américain',
    'Border Collie', 'Beagle', 'Boxer', 'Braque Allemand', 'Braque de Weimar',
    'Bulldog', 'Bull Terrier', 'Caniche', 'Carlin', 'Teckel', 'Dalmatien',
    'Doberman', 'Dogue Allemand', 'Dogue de Bordeaux', 'Dogue Argentin',
    'Épagneul Breton', 'Fox Terrier', 'Husky Sibérien', 'Jack Russell Terrier',
    'Lhassa Apso', 'Malamute', 'Mastiff', 'Pékinois', 'Pinscher', 'Pitbull',
    'Pointer', 'Rottweiler', 'Saint-Bernard', 'Samoyède', 'Schnauzer',
    'Setter Anglais', 'Setter Irlandais', 'Shar-Pei', 'Shiba Inu', 'Shih Tzu',
    'Spitz', 'Springer Anglais', 'Staffordshire Bull Terrier', 'American Staffordshire Terrier',
    'Terre-Neuve', 'Welsh Corgi', 'West Highland White Terrier', 'Westie',
    'Whippet', 'Yorkshire Terrier', 'Akita Inu', 'Basenji', 'Basset Hound',
    'Bichon Frisé', 'Bichon Maltais', 'Boston Terrier', 'Bouvier Bernois',
    'Cane Corso', 'Chow-Chow', 'Colley', 'Coton de Tuléar', 'Griffon',
    'Lévrier Afghan', 'Lévrier Greyhound', 'Leonberg', 'Malinois',
    'Papillon', 'Rhodesian Ridgeback', 'Scottie', 'Shetland', 'Vizsla'
  ].sort();

  // Races de chiens populaires à afficher par défaut
  const DOG_BREEDS_POPULAR = [
    'Berger Australien', 'Bouledogue Français', 'Golden Retriever', 
    'Labrador Retriever', 'Chihuahua', 'Jack Russell Terrier'
  ];

  // Races de chats
  const CAT_BREEDS = [
    'Européen', 'Persan', 'Maine Coon', 'Siamois', 'British Shorthair',
    'Ragdoll', 'Bengal', 'Abyssin', 'Sacré de Birmanie', 'Chartreux',
    'Sphynx', 'Scottish Fold', 'Norvégien', 'Sibérien', 'Exotic Shorthair',
    'Devon Rex', 'Cornish Rex', 'Burmese', 'Oriental', 'Tonkinois',
    'Russian Blue', 'Somali', 'Turkish Angora', 'Savannah', 'Balinais',
    'Bombay', 'Havana Brown', 'Korat', 'Manx', 'Ocicat',
    'Ragamuffin', 'Selkirk Rex', 'Singapura', 'Snowshoe', 'Toyger',
    'Turkish Van', 'American Curl', 'American Shorthair', 'Bleu Russe'
  ].sort();

  // Races de chats populaires à afficher par défaut
  const CAT_BREEDS_POPULAR = [
    'Européen', 'Maine Coon', 'British Shorthair', 
    'Bengal', 'Persan', 'Sacré de Birmanie'
  ];

  const SYMPTOMS = {
    joints: {
      question: 'Quels signes avez-vous remarqué chez {name} ?',
      options: [
        { label: 'Il boite ou traîne la patte', value: 'limping' },
        { label: 'Difficulté à se lever le matin', value: 'stiffness' },
        { label: 'Évite les escaliers ou sauter', value: 'avoids_stairs' },
        { label: 'Moins joueur qu\'avant', value: 'less_playful' },
        { label: 'Raideur après l\'effort', value: 'post_exercise' },
        { label: 'Prévention (sportif/senior)', value: 'prevention' }
      ]
    },
    digestion: {
      question: 'Quels symptômes digestifs avez-vous observé ?',
      options: [
        { label: 'Diarrhée occasionnelle', value: 'occasional_diarrhea', product: 'charbon-vegetal-actif-chien-et-chat' },
        { label: 'A mangé quelque chose de suspect', value: 'intoxication', product: 'charbon-vegetal-actif-chien-et-chat' },
        { label: 'Détox ponctuelle', value: 'detox', product: 'charbon-vegetal-actif-chien-et-chat' },
        { label: 'Selles molles régulières', value: 'loose_stool', product: 'probiotiques-chien-et-chat' },
        { label: 'Constipation', value: 'constipation', product: 'probiotiques-chien-et-chat' },
        { label: 'Vomissements fréquents', value: 'vomiting', product: 'probiotiques-chien-et-chat' },
        { label: 'Gaz / ballonnements', value: 'gas', product: 'probiotiques-chien-et-chat' },
        { label: 'Sensibilité alimentaire', value: 'food_sensitivity', product: 'probiotiques-chien-et-chat' }
      ]
    },
    skin: {
      question: 'Que remarquez-vous chez {name} ?',
      options: [
        { label: 'Se gratte souvent', value: 'scratching' },
        { label: 'Perte de poils excessive', value: 'hair_loss' },
        { label: 'Pelage terne / sec', value: 'dull_coat' },
        { label: 'Rougeurs / irritations', value: 'redness' },
        { label: 'Allergies saisonnières', value: 'seasonal_allergies' },
        { label: 'Hotspots / plaies de léchage', value: 'hotspots' }
      ]
    },
    immunity: {
      question: 'Qu\'avez-vous remarqué ?',
      options: [
        { label: 'Fatigue / manque d\'énergie', value: 'fatigue' },
        { label: 'Souvent malade', value: 'often_sick' },
        { label: 'Convalescence', value: 'recovery' },
        { label: 'Signes de vieillissement', value: 'aging' },
        { label: 'Prévention / renforcement', value: 'boost' }
      ]
    },
    stress: {
      question: 'Dans quelles situations {name} est-il stressé ?',
      options: [
        { label: 'Quand il reste seul', value: 'separation' },
        { label: 'En voiture / transport', value: 'travel' },
        { label: 'Bruits forts (orages, feux d\'artifice)', value: 'noise' },
        { label: 'Avec d\'autres animaux', value: 'other_animals' },
        { label: 'Avec des inconnus', value: 'strangers' },
        { label: 'Anxiété générale', value: 'general' }
      ]
    },
    dental: {
      question: 'Quels problèmes dentaires avez-vous remarqué ?',
      options: [
        { label: 'Mauvaise haleine', value: 'bad_breath', product: 'hygiene-dentaire-chien-et-chat' },
        { label: 'Tartre visible', value: 'tartar', product: 'hygiene-dentaire-chien-et-chat' },
        { label: 'Gencives rouges / gingivite', value: 'gingivitis', product: 'spray-propolis-chien-chat' },
        { label: 'Plaie / blessure dans la bouche', value: 'mouth_wound', product: 'spray-propolis-chien-chat' },
        { label: 'Difficulté à manger', value: 'eating_difficulty', product: 'spray-propolis-chien-chat' },
        { label: 'Prévention', value: 'prevention', product: 'hygiene-dentaire-chien-et-chat' }
      ]
    },
    urinary: {
      question: 'Que remarquez-vous ?',
      options: [
        { label: 'Urine souvent / difficulté', value: 'frequent_urination' },
        { label: 'Sang dans les urines', value: 'blood_in_urine' },
        { label: 'Inconfort visible', value: 'discomfort' },
        { label: 'Prévention / renforcement', value: 'prevention' }
      ]
    },
    parasites: {
      question: 'Quel type de protection recherchez-vous ?',
      options: [
        { label: 'Vers intestinaux', value: 'worms', product: 'vermi-protect-chien-chat' },
        { label: 'Puces', value: 'fleas', product: 'vinaigre-des-4-voleurs-chien-chat' },
        { label: 'Tiques', value: 'ticks', product: 'vinaigre-des-4-voleurs-chien-chat' },
        { label: 'Protection externe complète', value: 'external_protection', product: 'vinaigre-des-4-voleurs-chien-chat' },
        { label: 'Protection interne (vers)', value: 'internal_protection', product: 'vermi-protect-chien-chat' }
      ]
    },
    prevention: {
      question: 'Quel aspect souhaitez-vous renforcer ?',
      options: [
        { label: 'Vitalité générale', value: 'vitality' },
        { label: 'Pelage brillant', value: 'coat' },
        { label: 'Articulations', value: 'joints_prev' },
        { label: 'Bien-être global', value: 'wellbeing' }
      ]
    },
    vision: {
      question: 'Que remarquez-vous au niveau des yeux de {name} ?',
      options: [
        { label: 'Yeux qui coulent / larmoient', value: 'watery_eyes' },
        { label: 'Opacité / voile sur l\'œil', value: 'opacity' },
        { label: 'Se cogne / hésite dans le noir', value: 'night_vision' },
        { label: 'Prévention (chien senior)', value: 'prevention' }
      ]
    }
  };

  // Produit par défaut pour chaque préoccupation (peut être overridé par le symptôme)
  const PRODUCT_MAP = {
    joints: 'complement-articulation-chien-et-chat',
    digestion: 'probiotiques-chien-et-chat',
    skin: 'demangeaisons-chien-chat',
    immunity: 'immunite-chien-et-chat',
    stress: 'relaxation-chien-et-chat',
    dental: 'hygiene-dentaire-chien-et-chat',
    urinary: 'urino-regule-chien-chat',
    parasites: 'vermi-protect-chien-chat',
    prevention: 'huile-de-saumon',
    vision: 'vision-chien-chat'
  };

  const CONCERN_LABELS = {
    joints: 'Articulations / Mobilité', digestion: 'Digestion / Transit',
    skin: 'Peau / Pelage', immunity: 'Immunité / Vitalité',
    stress: 'Stress / Anxiété', dental: 'Hygiène dentaire',
    urinary: 'Urinaire / Reins', parasites: 'Parasites', 
    prevention: 'Prévention générale', vision: 'Vision'
  };

  /* ========== STATE ========== */

  const state = {
    currentStep: 0,
    answers: {
      pet_type: null,
      pet_name: null,
      pet_breed: null,
      age_value: 1,
      age_unit: 'years',
      birthdate: null,
      pet_weight: null, // small, medium, large, xlarge
      activity_level: null,
      medical_treatment: null,
      health_conditions: [],
      main_concerns: [], // array pour multi-sélection (1-3)
      symptoms_by_concern: {}, // objet avec symptômes par préoccupation
      symptoms: [], // KEPT for backward compatibility
      duration_by_concern: {}, // objet avec durée par préoccupation
      duration: null, // KEPT for backward compatibility
      email: null,
      first_name: null,
      phone: null
    },
    productData: null
  };

  /* ========== DOM ========== */

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  let app, container, resultPage, stepsWrapper;
  let progressCurrent, progressTotal, progressFill;
  let prevBtn, nextBtn, navBar;

  /* ========== INIT ========== */

  function init() {
    app = $('#quiz-app');
    if (!app) return;

    container = $('[data-quiz-container]', app);
    resultPage = $('[data-quiz-result]', app);
    stepsWrapper = $('[data-steps-wrapper]', app);
    progressCurrent = $('[data-progress-current]', app);
    progressTotal = $('[data-progress-total]', app);
    progressFill = $('[data-progress-fill]', app);
    prevBtn = $('[data-prev]', app);
    nextBtn = $('[data-next]', app);
    navBar = $('[data-quiz-nav]', app);

    container.style.display = 'block';
    state.currentStep = 0;
    
    bindEvents();
    initConcernCheckboxes();
    renderStep();
  }

  function bindEvents() {
    // Options click
    stepsWrapper.addEventListener('click', handleOptionClick);

    // Pet name
    const nameInput = $('[data-input="pet_name"]', app);
    if (nameInput) {
      nameInput.addEventListener('input', () => {
        state.answers.pet_name = nameInput.value.trim();
        updateNavButtons();
        updatePetNameSpans();
      });
      nameInput.addEventListener('keydown', e => {
        if (e.key === 'Enter' && state.answers.pet_name) goNext();
      });
    }

    // Age controls
    const ageValue = $('[data-input="age_value"]', app);
    const ageUnit = $('[data-input="age_unit"]', app);
    const ageMinus = $('[data-age-minus]', app);
    const agePlus = $('[data-age-plus]', app);

    if (ageValue) {
      ageValue.addEventListener('input', () => {
        state.answers.age_value = parseInt(ageValue.value) || 1;
        updateNavButtons();
      });
    }
    if (ageUnit) {
      ageUnit.addEventListener('change', () => {
        state.answers.age_unit = ageUnit.value;
      });
    }
    if (ageMinus) {
      ageMinus.addEventListener('click', () => {
        const current = parseInt(ageValue.value) || 1;
        if (current > 1) {
          ageValue.value = current - 1;
          state.answers.age_value = current - 1;
        }
      });
    }
    if (agePlus) {
      agePlus.addEventListener('click', () => {
        const current = parseInt(ageValue.value) || 1;
        if (current < 30) {
          ageValue.value = current + 1;
          state.answers.age_value = current + 1;
        }
      });
    }

    // Age toggle (Âge / Date de naissance)
    $$('[data-age-mode]', app).forEach(btn => {
      btn.addEventListener('click', () => {
        const mode = btn.dataset.ageMode;
        $$('[data-age-mode]', app).forEach(b => b.classList.remove('quiz__toggle-btn--active'));
        btn.classList.add('quiz__toggle-btn--active');
        
        $('[data-age-input-section]', app).style.display = mode === 'age' ? '' : 'none';
        $('[data-birthdate-section]', app).style.display = mode === 'birthdate' ? '' : 'none';
        
        // Initialiser les selects birthdate si mode birthdate
        if (mode === 'birthdate') {
          initBirthdateSelects();
        }
        
        updateNavButtons();
      });
    });

    // Breed search
    const breedSearch = $('[data-breed-search]', app);
    if (breedSearch) {
      breedSearch.addEventListener('input', () => {
        renderBreedSuggestions(breedSearch.value);
      });
    }

    // Breed unknown button
    const breedUnknown = $('[data-breed-unknown]', app);
    if (breedUnknown) {
      breedUnknown.addEventListener('click', () => {
        state.answers.pet_breed = 'Croisé / Inconnu';
        breedUnknown.classList.add('is-selected');
        
        // Désélectionner les tags de race
        $$('.quiz__breed-tag.is-selected', app).forEach(t => t.classList.remove('is-selected'));
        
        updateNavButtons();
      });
    }

    // Health conditions checkboxes
    $$('[data-condition]', app).forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const conditions = [];
        $$('[data-condition]:checked', app).forEach(cb => {
          conditions.push(cb.dataset.condition);
        });
        state.answers.health_conditions = conditions;
        updateNavButtons();
      });
    });

    // Save Profile inputs
    const emailInput = $('[data-input="email"]', app);
    if (emailInput) {
      emailInput.addEventListener('input', () => {
        state.answers.email = emailInput.value.trim();
        updateNavButtons();
      });
    }

    const firstNameInput = $('[data-input="first_name"]', app);
    if (firstNameInput) {
      firstNameInput.addEventListener('input', () => {
        state.answers.first_name = firstNameInput.value.trim();
        updateNavButtons();
      });
    }

    const phoneInput = $('[data-input="phone"]', app);
    if (phoneInput) {
      phoneInput.addEventListener('input', () => {
        state.answers.phone = phoneInput.value.trim();
      });
    }

    // Navigation
    prevBtn.addEventListener('click', goPrev);
    nextBtn.addEventListener('click', goNext);

    $('[data-submit-profile]', app)?.addEventListener('click', submitProfile);
    $('[data-profile-back]', app)?.addEventListener('click', goPrev);
    $('[data-qty-minus]', app)?.addEventListener('click', () => changeQty(-1));
    $('[data-qty-plus]', app)?.addEventListener('click', () => changeQty(1));
    $('[data-qty-input]', app)?.addEventListener('change', updateCartTotal);
    $('[data-subscription-toggle]', app)?.addEventListener('change', updateCartTotal);
    $('[data-add-to-cart]', app)?.addEventListener('click', addToCart);
    $('[data-restart-quiz]', app)?.addEventListener('click', restartQuiz);
    $('[data-sticky-add-to-cart]', app)?.addEventListener('click', addToCart);
  }

  /* ========== BIRTHDATE SELECTS ========== */

  function initBirthdateSelects() {
    const daySelect = $('[data-birthdate-day]', app);
    const monthSelect = $('[data-birthdate-month]', app);
    const yearSelect = $('[data-birthdate-year]', app);
    
    if (!daySelect || !monthSelect || !yearSelect) return;

    // Remplir les jours (1-31)
    if (daySelect.options.length <= 1) {
      for (let d = 1; d <= 31; d++) {
        const opt = document.createElement('option');
        opt.value = d;
        opt.textContent = d;
        daySelect.appendChild(opt);
      }
    }

    // Remplir les années (de l'année actuelle jusqu'à 30 ans en arrière)
    if (yearSelect.options.length <= 1) {
      const currentYear = new Date().getFullYear();
      for (let y = currentYear; y >= currentYear - 30; y--) {
        const opt = document.createElement('option');
        opt.value = y;
        opt.textContent = y;
        yearSelect.appendChild(opt);
      }
    }

    // Event listeners pour calculer l'âge quand une date est complète
    [daySelect, monthSelect, yearSelect].forEach(select => {
      select.addEventListener('change', () => {
        updateBirthdateFromSelects();
      });
    });
  }

  function updateBirthdateFromSelects() {
    const day = $('[data-birthdate-day]', app)?.value;
    const month = $('[data-birthdate-month]', app)?.value;
    const year = $('[data-birthdate-year]', app)?.value;

    // Vérifier que toutes les valeurs sont sélectionnées
    if (!day || !month || month === '' || !year) {
      updateNavButtons();
      return;
    }

    // Créer la date
    const birthDate = new Date(parseInt(year), parseInt(month), parseInt(day));
    const today = new Date();

    // Vérifier que la date est valide et pas dans le futur
    if (birthDate > today) {
      updateNavButtons();
      return;
    }

    // Stocker la date
    state.answers.birthdate = `${year}-${String(parseInt(month) + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    // Calculer l'âge
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    
    if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
      years--;
      months += 12;
    }

    // Mettre à jour l'âge dans le state
    if (years >= 1) {
      state.answers.age_value = years;
      state.answers.age_unit = 'years';
    } else {
      state.answers.age_value = Math.max(1, months);
      state.answers.age_unit = 'months';
    }

    updateNavButtons();
  }

  /* ========== NAVIGATION ========== */

  function goNext() {
    const steps = getActiveSteps();
    const currentStepId = steps[state.currentStep];
    
    if (!isStepValid(currentStepId)) return;
    
    if (state.currentStep < steps.length - 1) {
      state.currentStep++;
      renderStep('next');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function goPrev() {
    if (state.currentStep > 0) {
      state.currentStep--;
      renderStep('prev');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function renderStep(direction) {
    const steps = getActiveSteps();
    const stepId = steps[state.currentStep];
    const total = steps.length;

    // Cacher toutes les étapes
    $$('.quiz__step', stepsWrapper).forEach(s => s.style.display = 'none');

    // Afficher l'étape actuelle
    const stepEl = $(`[data-step-id="${stepId}"]`, stepsWrapper);
    if (!stepEl) return;
    stepEl.style.display = '';

    // Animation
    stepEl.removeAttribute('data-direction');
    if (direction === 'prev') stepEl.setAttribute('data-direction', 'prev');
    stepEl.style.animation = 'none';
    stepEl.offsetHeight;
    stepEl.style.animation = '';

    fillDynamicContent(stepId);

    // Progression et navigation
    const progressText = $('.quiz__progress-text', app);
    
    if (stepId === 'save_profile') {
      // Étape finale : cacher la progression et les boutons nav
      if (progressText) progressText.style.display = 'none';
      prevBtn.style.visibility = 'hidden';
      nextBtn.style.visibility = 'hidden';
      setTimeout(() => $('[data-input="email"]', app)?.focus(), 350);
    } else {
      // Autres étapes : affichage normal
      const currentNum = state.currentStep + 1;
      if (progressText) {
        progressText.style.display = '';
        progressText.innerHTML = `Question <span data-progress-current>${currentNum}</span> sur <span data-progress-total>${total}</span>`;
      }
      prevBtn.style.visibility = '';
      nextBtn.style.visibility = '';
    }

    updateNavButtons();
    updatePetNameSpans();

    // Focus sur pet_name
    if (stepId === 'pet_name') {
      setTimeout(() => $('[data-input="pet_name"]', app)?.focus(), 350);
    }
  }

  function updateNavButtons() {
    const steps = getActiveSteps();
    const stepId = steps[state.currentStep];
    const isFirstStep = state.currentStep === 0;
    const isValid = isStepValid(stepId);

    prevBtn.disabled = isFirstStep;
    prevBtn.style.opacity = isFirstStep ? '0.5' : '1';

    nextBtn.disabled = !isValid;
    nextBtn.style.opacity = isValid ? '1' : '0.5';
  }

  /* ========== DYNAMIC CONTENT ========== */

  function fillDynamicContent(stepId) {
    if (stepId === 'pet_breed') {
      renderBreedSuggestions();
    }

    if (stepId === 'activity_level') {
      const label = $('[data-activity-label]', app);
      if (label && state.answers.activity_level) {
        label.textContent = getActivityLabel(state.answers.activity_level, state.answers.pet_name);
        label.style.display = '';
      } else if (label) {
        label.style.display = 'none';
      }
    }

    if (stepId === 'symptoms') {
      const concerns = state.answers.main_concerns;
      if (!concerns || concerns.length === 0) return;

      const sectionsContainer = $('[data-symptoms-sections]', app);
      if (!sectionsContainer) return;

      // Couleurs par préoccupation (pour la bordure gauche)
      const CONCERN_COLORS = {
        joints: '#A74C71',      // Articulations - Rose/Bordeaux
        digestion: '#5A9EB1',   // Digestion - Bleu canard
        skin: '#BD7842',        // Peau/Pelage - Marron/Orange
        immunity: '#D7AA4E',    // Immunité - Doré
        stress: '#679C82',      // Stress - Vert sauge
        dental: '#00A38C',      // Dentaire - Turquoise
        urinary: '#3DAB5F',     // Urinaire - Vert
        parasites: '#E84E4F',   // Parasites - Rouge
        prevention: '#2C4A5A',  // Prévention - Primary
        vision: '#514A9E'       // Vision - Violet/Indigo
      };

      // Générer les sections
      let html = '';
      concerns.forEach((concern, index) => {
        const data = SYMPTOMS[concern];
        if (!data) return;

        const label = CONCERN_LABELS[concern] || concern;
        const color = CONCERN_COLORS[concern] || '#4445DC';
        const currentSymptoms = state.answers.symptoms_by_concern[concern] || [];
        const sectionNumber = index + 1;

        html += `
          <div class="quiz__symptoms-section" data-concern-section="${concern}" style="--section-color: ${color}">
            <div class="quiz__symptoms-section-header">
              <span class="quiz__symptoms-section-number">${sectionNumber}</span>
              <h3 class="quiz__symptoms-section-title">${label}</h3>
            </div>
            <div class="quiz__checkbox-grid">
              ${data.options.map(opt => `
                <label class="quiz__checkbox-item">
                  <input type="checkbox" data-symptom="${opt.value}" data-concern="${concern}" ${currentSymptoms.includes(opt.value) ? 'checked' : ''} />
                  <span class="quiz__checkbox-box"></span>
                  <span class="quiz__checkbox-label">${opt.label}</span>
                </label>
              `).join('')}
            </div>
          </div>
        `;
      });

      sectionsContainer.innerHTML = html;

      // Bind events pour les symptômes
      $$('[data-symptom]', sectionsContainer).forEach(cb => {
        cb.addEventListener('change', () => {
          const concern = cb.dataset.concern;
          const symptoms = [];
          $$(`[data-symptom][data-concern="${concern}"]:checked`, sectionsContainer).forEach(c => {
            symptoms.push(c.dataset.symptom);
          });
          state.answers.symptoms_by_concern[concern] = symptoms;
          
          // Aussi mettre à jour le tableau plat pour backward compatibility
          state.answers.symptoms = Object.values(state.answers.symptoms_by_concern).flat();
          
          updateNavButtons();
        });
      });

      // Mettre à jour le titre
      const titleEl = $('[data-symptoms-question]', app);
      if (titleEl) {
        if (concerns.length === 1) {
          const data = SYMPTOMS[concerns[0]];
          titleEl.textContent = data?.question?.replace('{name}', state.answers.pet_name || 'votre compagnon') || 'Décrivez les symptômes observés';
        } else {
          titleEl.textContent = `Décrivez les symptômes de ${state.answers.pet_name || 'votre compagnon'}`;
        }
      }

      // Message véto (utiliser le premier concern pour le tip)
      const vetText = $('[data-symptoms-vet-text]', app);
      if (vetText && concerns.length > 0 && VET_TIPS[concerns[0]]) {
        if (concerns.length === 1) {
          vetText.textContent = VET_TIPS[concerns[0]].replace('{name}', state.answers.pet_name || 'votre compagnon');
        } else {
          vetText.textContent = `Ces informations nous aident à cibler précisément les compléments les plus adaptés à ${state.answers.pet_name || 'votre compagnon'}.`;
        }
      }
    }

    if (stepId === 'duration') {
      const concerns = state.answers.main_concerns;
      if (!concerns || concerns.length === 0) return;

      const sectionsContainer = $('[data-duration-sections]', app);
      if (!sectionsContainer) return;

      // Couleurs par préoccupation
      const CONCERN_COLORS = {
        joints: '#A74C71',
        digestion: '#5A9EB1',
        skin: '#BD7842',
        immunity: '#D7AA4E',
        stress: '#679C82',
        dental: '#00A38C',
        urinary: '#3DAB5F',
        parasites: '#E84E4F',
        prevention: '#2C4A5A',
        vision: '#514A9E'
      };

      const DURATION_OPTIONS = [
        { value: 'days', emoji: '📅', label: 'Quelques jours' },
        { value: 'weeks', emoji: '📆', label: 'Quelques semaines' },
        { value: 'months', emoji: '🗓️', label: 'Plusieurs mois' },
        { value: 'chronic', emoji: '♾️', label: 'Chronique' }
      ];

      // Mettre à jour le titre et le hint
      const titleEl = $('[data-duration-question]', app);
      const hintEl = $('[data-duration-hint]', app);
      
      if (concerns.length === 1) {
        if (titleEl) titleEl.textContent = `Depuis combien de temps observez-vous ces signes chez ${state.answers.pet_name || 'votre compagnon'} ?`;
        if (hintEl) hintEl.style.display = 'none';
      } else {
        if (titleEl) titleEl.textContent = 'Depuis combien de temps observez-vous ces signes ?';
        if (hintEl) hintEl.style.display = '';
      }

      // Générer les sections
      let html = '';
      concerns.forEach((concern, index) => {
        const label = CONCERN_LABELS[concern] || concern;
        const color = CONCERN_COLORS[concern] || '#4445DC';
        const currentDuration = state.answers.duration_by_concern[concern] || null;
        const sectionNumber = index + 1;

        html += `
          <div class="quiz__duration-section" data-duration-section="${concern}" style="--section-color: ${color}">
            ${concerns.length > 1 ? `
              <div class="quiz__duration-section-header">
                <span class="quiz__duration-section-number">${sectionNumber}</span>
                <h3 class="quiz__duration-section-title">${label}</h3>
              </div>
            ` : ''}
            <div class="quiz__options quiz__options--2col quiz__options--duration">
              ${DURATION_OPTIONS.map(opt => `
                <button type="button" class="quiz__option-card quiz__option-card--duration ${currentDuration === opt.value ? 'is-selected' : ''}" data-duration-value="${opt.value}" data-duration-for="${concern}">
                  <span class="quiz__option-emoji">${opt.emoji}</span>
                  <span class="quiz__option-label">${opt.label}</span>
                </button>
              `).join('')}
            </div>
          </div>
        `;
      });

      sectionsContainer.innerHTML = html;

      // Bind events pour la durée
      $$('[data-duration-value]', sectionsContainer).forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const concern = this.dataset.durationFor;
          const value = this.dataset.durationValue;
          
          // Trouver la section parente
          const section = this.closest('.quiz__duration-section');
          if (!section) return;
          
          // Désélectionner TOUS les boutons dans cette section seulement
          const buttonsInSection = section.querySelectorAll('.quiz__option-card');
          buttonsInSection.forEach(function(b) {
            b.classList.remove('is-selected');
          });
          
          // Sélectionner ce bouton
          this.classList.add('is-selected');
          
          // Mettre à jour le state
          state.answers.duration_by_concern[concern] = value;
          
          // Backward compatibility : si une seule préoccupation, garder aussi duration
          if (state.answers.main_concerns.length === 1) {
            state.answers.duration = value;
          }
          
          updateNavButtons();
        });
      });
    }
  }

  /* ========== BREED SEARCH ========== */

  function getBreedList() {
    return state.answers.pet_type === 'cat' ? CAT_BREEDS : DOG_BREEDS;
  }

  function getPopularBreeds() {
    return state.answers.pet_type === 'cat' ? CAT_BREEDS_POPULAR : DOG_BREEDS_POPULAR;
  }

  function renderBreedSuggestions(filter = '') {
    const container = $('[data-breed-suggestions]', app);
    if (!container) return;

    const allBreeds = getBreedList();
    const popularBreeds = getPopularBreeds();
    
    let breeds;
    if (filter.trim()) {
      // Recherche fuzzy
      const search = filter.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      breeds = allBreeds.filter(breed => {
        const normalized = breed.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return normalized.includes(search);
      });
    } else {
      breeds = popularBreeds;
    }

    if (breeds.length === 0) {
      container.innerHTML = '<p class="quiz__breed-no-results">Aucune race trouvée. Essayez un autre terme ou choisissez "Je ne connais pas sa race".</p>';
      return;
    }

    container.innerHTML = breeds.map(breed => `
      <button type="button" class="quiz__breed-tag ${state.answers.pet_breed === breed ? 'is-selected' : ''}" data-breed="${breed}">
        ${breed}
      </button>
    `).join('');

    // Bind events
    $$('[data-breed]', container).forEach(btn => {
      btn.addEventListener('click', () => selectBreed(btn.dataset.breed));
    });
  }

  function selectBreed(breed) {
    state.answers.pet_breed = breed;
    
    // Désélectionner "Je ne connais pas"
    const unknownBtn = $('[data-breed-unknown]', app);
    if (unknownBtn) unknownBtn.classList.remove('is-selected');
    
    // Mettre à jour l'affichage
    renderBreedSuggestions($('[data-breed-search]', app)?.value || '');
    updateNavButtons();
  }

  function updatePetNameSpans() {
    const name = state.answers.pet_name || 'votre compagnon';
    $$('[data-pet-name]', app).forEach(el => el.textContent = name);
  }

  /* ========== OPTION HANDLING ========== */

  function handleOptionClick(e) {
    // Cartes poids
    const weightCard = e.target.closest('.quiz__weight-card');
    if (weightCard) {
      const stepEl = weightCard.closest('.quiz__step');
      $$('.quiz__weight-card', stepEl).forEach(c => c.classList.remove('is-selected'));
      weightCard.classList.add('is-selected');
      state.answers.pet_weight = weightCard.dataset.value;
      updateNavButtons();
      return;
    }

    // Checkboxes multi-select pour main_concerns - IGNORER, géré séparément
    const concernCheckbox = e.target.closest('.quiz__option-card--checkbox');
    if (concernCheckbox) {
      return; // Géré par initConcernCheckboxes()
    }

    // Boutons duration multi-sections - IGNORER, géré séparément
    const durationBtn = e.target.closest('[data-duration-value]');
    if (durationBtn) {
      return; // Géré par fillDynamicContent pour duration
    }

    // Option cards standard (single select)
    const card = e.target.closest('.quiz__option-card');
    if (!card) return;

    const stepEl = card.closest('.quiz__step');
    const stepId = stepEl?.dataset.stepId;
    const value = card.dataset.value;

    // Single select
    $$('.quiz__option-card', stepEl).forEach(c => c.classList.remove('is-selected'));
    card.classList.add('is-selected');
    state.answers[stepId] = value;

    // Activity label
    if (stepId === 'activity_level') {
      const label = $('[data-activity-label]', app);
      if (label) {
        label.textContent = getActivityLabel(value, state.answers.pet_name);
        label.style.display = '';
      }
    }

    // Medical treatment : afficher/masquer la section conditions
    if (stepId === 'medical_treatment') {
      const conditionsSection = $('[data-conditions-section]', app);
      if (conditionsSection) {
        if (value === 'yes') {
          conditionsSection.style.display = '';
          // Reset les conditions si on revient sur "oui"
          // Scroll vers la section
          setTimeout(() => {
            conditionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        } else {
          conditionsSection.style.display = 'none';
          // Reset les conditions si on choisit "non"
          state.answers.health_conditions = [];
          $$('[data-condition]', app).forEach(cb => cb.checked = false);
        }
      }
    }

    updateNavButtons();
    // Pas d'auto-avance, le client clique sur Suivant
  }

  /* ========== VALIDATION ========== */

  function isStepValid(stepId) {
    switch (stepId) {
      case 'pet_type': return !!state.answers.pet_type;
      case 'pet_name': return !!state.answers.pet_name;
      case 'pet_breed': return !!state.answers.pet_breed;
      case 'pet_age': 
        // Vérifier quel mode est actif (via le toggle button)
        const activeModeBtn = $('.quiz__toggle-btn--active[data-age-mode]', app);
        const currentMode = activeModeBtn ? activeModeBtn.dataset.ageMode : 'age';
        
        if (currentMode === 'birthdate') {
          // Mode date de naissance : vérifier que jour, mois et année sont sélectionnés
          const day = $('[data-birthdate-day]', app)?.value;
          const month = $('[data-birthdate-month]', app)?.value;
          const year = $('[data-birthdate-year]', app)?.value;
          return !!day && month !== '' && month !== null && !!year;
        } else {
          // Mode âge : toujours valide car il y a une valeur par défaut (1)
          return state.answers.age_value >= 1;
        }
      case 'pet_weight': return !!state.answers.pet_weight;
      case 'activity_level': return !!state.answers.activity_level;
      case 'medical_treatment': 
        // Si "non" sélectionné, c'est valide
        // Si "oui" sélectionné, il faut au moins une condition cochée
        if (state.answers.medical_treatment === 'no') return true;
        if (state.answers.medical_treatment === 'yes') return state.answers.health_conditions.length > 0;
        return false;
      case 'main_concern': return state.answers.main_concerns.length > 0;
      case 'symptoms': 
        // Vérifier qu'il y a au moins un symptôme pour chaque préoccupation
        const concernsSymp = state.answers.main_concerns;
        if (concernsSymp.length === 0) return false;
        return concernsSymp.every(c => {
          const symptomsForConcern = state.answers.symptoms_by_concern[c] || [];
          return symptomsForConcern.length > 0;
        });
      case 'duration':
        // Vérifier qu'il y a une durée pour chaque préoccupation
        const concernsDur = state.answers.main_concerns;
        if (concernsDur.length === 0) return false;
        return concernsDur.every(c => {
          return !!state.answers.duration_by_concern[c];
        });
      case 'save_profile': return isValidEmail(state.answers.email) && !!state.answers.first_name;
      default: return true;
    }
  }

  function isValidEmail(email) {
    return email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* ========== EMAIL & RESULT ========== */

  function fillResultPreview() {
    const preview = $('[data-result-preview]', app);
    if (!preview) return;

    const concerns = state.answers.main_concerns;
    const emoji = state.answers.pet_type === 'cat' ? '🐱' : '🐕';

    if (concerns.length === 1) {
      preview.innerHTML = `
        <div class="quiz__preview-blur">
          <div class="quiz__preview-product">
            <div class="quiz__preview-image"></div>
            <div class="quiz__preview-info">
              <div class="quiz__preview-name">${CONCERN_LABELS[concerns[0]] || 'Complément'}</div>
              <div class="quiz__preview-for">${emoji} Pour ${state.answers.pet_name || 'votre compagnon'}</div>
            </div>
          </div>
        </div>
      `;
    } else {
      preview.innerHTML = `
        <div class="quiz__preview-blur">
          <div class="quiz__preview-product">
            <div class="quiz__preview-image"></div>
            <div class="quiz__preview-info">
              <div class="quiz__preview-name">${concerns.length} compléments recommandés</div>
              <div class="quiz__preview-for">${emoji} Pour ${state.answers.pet_name || 'votre compagnon'}</div>
            </div>
          </div>
        </div>
      `;
    }
  }

  async function submitProfile() {
    if (!isValidEmail(state.answers.email) || !state.answers.first_name) return;

    const btn = $('[data-submit-profile]', app);
    btn.disabled = true;
    btn.innerHTML = 'Chargement...';

    // Labels pour Klaviyo
    const WEIGHT_LABELS = {
      small: '1-10 kg',
      medium: '11-20 kg',
      large: '21-30 kg',
      xlarge: '31 kg+'
    };

    // Préparer les données des préoccupations
    const concerns = state.answers.main_concerns;
    const concernLabels = concerns.map(c => CONCERN_LABELS[c] || c).join(', ');

    // Klaviyo
    if (window._learnq) {
      window._learnq.push(['identify', {
        '$email': state.answers.email,
        '$first_name': state.answers.first_name,
        '$phone_number': state.answers.phone ? '+33' + state.answers.phone.replace(/^0/, '') : '',
        'pet_type': state.answers.pet_type,
        'pet_name': state.answers.pet_name,
        'pet_breed': state.answers.pet_breed,
        'pet_age': `${state.answers.age_value} ${state.answers.age_unit === 'years' ? 'ans' : 'mois'}`,
        'pet_weight': state.answers.pet_type === 'cat' ? 'Chat' : WEIGHT_LABELS[state.answers.pet_weight] || '',
        'activity_level': state.answers.activity_level,
        'health_conditions': state.answers.health_conditions.join(', '),
        'main_concerns': concernLabels,
        'concerns_count': concerns.length,
        'symptoms': state.answers.symptoms.join(', ')
      }]);

      window._learnq.push(['track', 'Quiz Completed', {
        'concerns': concernLabels,
        'concerns_count': concerns.length,
        'pet_type': state.answers.pet_type,
        'pet_breed': state.answers.pet_breed
      }]);
    }

    await fetchAndShowResult();
  }

  async function fetchAndShowResult() {
    const concerns = state.answers.main_concerns;
    if (!concerns || concerns.length === 0) return;

    // Déterminer les produits pour chaque préoccupation
    // Option B : Si plusieurs symptômes avec différents produits, on recommande TOUS les produits
    const products = [];
    
    for (const concern of concerns) {
      const symptomsForConcern = state.answers.symptoms_by_concern[concern] || [];
      
      // Collecter tous les produits uniques basés sur les symptômes cochés
      const productsForConcern = new Set();
      
      if (symptomsForConcern.length > 0 && SYMPTOMS[concern]) {
        const symptomOptions = SYMPTOMS[concern].options;
        
        for (const symptomValue of symptomsForConcern) {
          const symptomOption = symptomOptions.find(opt => opt.value === symptomValue);
          if (symptomOption && symptomOption.product) {
            // Ajouter le produit spécifique du symptôme
            productsForConcern.add(symptomOption.product);
          }
        }
      }
      
      // Si aucun symptôme n'a de produit spécifique, utiliser le produit par défaut
      if (productsForConcern.size === 0) {
        const defaultProduct = PRODUCT_MAP[concern];
        if (defaultProduct) {
          productsForConcern.add(defaultProduct);
        }
      }
      
      // Ajouter tous les produits de cette préoccupation à la liste globale
      for (const handle of productsForConcern) {
        if (!products.includes(handle)) {
          products.push(handle);
        }
      }
    }
    
    if (products.length === 0) return;

    // Labels pour les conditions de santé
    const HEALTH_CONDITION_LABELS = {
      allergy: 'Allergies',
      diabetes: 'Diabète',
      kidney: 'Insuffisance rénale',
      liver: 'Problèmes hépatiques',
      thyroid: 'Troubles thyroïdiens',
      cushing: 'Syndrome de Cushing',
      addison: 'Maladie d\'Addison',
      cancer: 'Cancer',
      ibd: 'Maladie inflammatoire intestin',
      obesity: 'Obésité',
      convalescence: 'Convalescence',
      dental: 'Problèmes dentaires',
      epilepsy: 'Épilepsie',
      cardiac: 'Problème cardiaque',
      sensitive_stomach: 'Estomac sensible',
      skin_coat: 'Problèmes peau/poils',
      pancreatitis: 'Pancréatite'
    };

    // Construire la liste des conditions de santé lisibles
    const healthConditionsLabels = state.answers.health_conditions
      .map(c => HEALTH_CONDITION_LABELS[c] || c)
      .join(', ');

    // Construire les paramètres pour la page résultat
    const paramsObj = {
      from_quiz: 'true',
      pet_name: state.answers.pet_name || '',
      pet_type: state.answers.pet_type || 'dog',
      breed: state.answers.pet_breed || '',
      age: `${state.answers.age_value} ${state.answers.age_unit === 'years' ? 'ans' : 'mois'}`,
      weight: state.answers.pet_weight || '',
      concerns: concerns.join(','),
      products: products.join(','),
      health_conditions: healthConditionsLabels
    };
    
    // Ajouter la date de naissance si elle existe (format YYYY-MM-DD)
    if (state.answers.birthdate && typeof state.answers.birthdate === 'string' && state.answers.birthdate.includes('-')) {
      // Convertir de YYYY-MM-DD en DD/MM/YYYY
      const parts = state.answers.birthdate.split('-');
      if (parts.length === 3) {
        const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
        paramsObj.birthdate = formattedDate;
      }
    }
    
    const params = new URLSearchParams(paramsObj);

    // Toujours rediriger vers la page résultat
    window.location.href = `/pages/resultat-diagnostic?${params.toString()}`;
  }

  /* ========== RESULT RENDERING (LEGACY - kept for fallback) ========== */

  const WEIGHT_LABELS = {
    small: '1-10 kg',
    medium: '11-20 kg',
    large: '21-30 kg',
    xlarge: '31 kg+'
  };

  function renderProfileSection() {
    const emoji = state.answers.pet_type === 'cat' ? '🐱' : '🐕';
    const petType = state.answers.pet_type === 'cat' ? 'Chat' : 'Chien';
    const age = `${state.answers.age_value} ${state.answers.age_unit === 'years' ? 'ans' : 'mois'}`;
    const weight = state.answers.pet_type === 'cat' ? '' : WEIGHT_LABELS[state.answers.pet_weight] || '';
    const concern = CONCERN_LABELS[state.answers.main_concern] || '';

    $('[data-result-pet-emoji]', app).textContent = emoji;

    const list = $('[data-profile-list]', app);
    let html = `
      <li><strong>Type :</strong> ${petType}</li>
      <li><strong>Âge :</strong> ${age}</li>
    `;
    if (weight) {
      html += `<li><strong>Poids :</strong> ${weight}</li>`;
    }
    html += `<li><strong>Préoccupation :</strong> ${concern}</li>`;
    list.innerHTML = html;
  }

  function renderProductHero(product) {
    const img = $('[data-product-image]', app);
    if (img && product.featured_image) {
      img.src = product.featured_image;
      img.alt = product.title;
    }

    $('[data-product-name]', app).textContent = product.title;
    $('[data-product-badge]', app).textContent = 'Recommandé pour ' + state.answers.pet_name;
    $('[data-product-price]', app).textContent = formatPrice(product.price);
  }

  function formatPrice(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function renderDosage(product) {
    const weightCategory = state.answers.pet_weight || 'medium';
    const isCat = state.answers.pet_type === 'cat';
    
    // Posologie selon la tranche
    const DOSAGE_INFO = {
      small: { grams: 1, text: '1 cuillère par jour', label: '1-10 kg' },
      medium: { grams: 2, text: '2 cuillères par jour', label: '11-20 kg' },
      large: { grams: 3, text: '3 cuillères par jour', label: '21-30 kg' },
      xlarge: { grams: 4, text: '4 cuillères par jour', label: '31 kg+' }
    };

    // Pour les chats, toujours la même posologie
    const dosage = isCat 
      ? { grams: 1, text: '1 cuillère par jour', label: 'Chat' }
      : DOSAGE_INFO[weightCategory] || DOSAGE_INFO.medium;

    let potGrams = 100;
    const variant = product.variants?.[0];
    if (variant) {
      const match = variant.title?.match(/(\d+)\s*(g|ml)/i);
      if (match) potGrams = parseInt(match[1]);
    }

    const potDuration = Math.floor(potGrams / dosage.grams);
    const potsNeeded = Math.ceil(90 / potDuration);

    $('[data-dosage-weight]', app).textContent = dosage.label;
    $('[data-dosage-daily]', app).textContent = dosage.text;
    $('[data-dosage-pot-duration]', app).textContent = `${potDuration} jours`;
    $('[data-dosage-pots-needed]', app).textContent = `${potsNeeded} pot${potsNeeded > 1 ? 's' : ''}`;

    const qtyInput = $('[data-qty-input]', app);
    if (qtyInput) qtyInput.value = potsNeeded;
  }

  /* ========== CART ========== */

  function renderCartSection(product) {
    $('[data-cart-product-name]', app).textContent = product.title;
    $('[data-cart-unit-price]', app).textContent = formatPrice(product.price);
    $('[data-product-link]', app).href = `/products/${product.handle}`;
    updateCartTotal();
  }

  function changeQty(delta) {
    const input = $('[data-qty-input]', app);
    let val = Math.max(1, Math.min(10, (parseInt(input.value) || 1) + delta));
    input.value = val;
    updateCartTotal();
  }

  function updateCartTotal() {
    const qty = parseInt($('[data-qty-input]', app)?.value) || 1;
    const price = parseInt(app.dataset.productPrice) || 2500;
    const isSub = $('[data-subscription-toggle]', app)?.checked;
    const total = price * qty;
    const display = isSub ? Math.round(total * 0.9) : total;

    const cartTotal = $('[data-cart-total]', app);
    if (cartTotal) cartTotal.textContent = formatPrice(display);

    const subPrice = $('[data-subscription-price]', app);
    if (subPrice) subPrice.textContent = formatPrice(Math.round(total * 0.9));
  }

  function addToCart() {
    const variantId = app.dataset.variantId;
    if (!variantId) {
      // Rediriger vers la page résultat si multi-produits
      const concerns = state.answers.main_concerns;
      if (concerns.length > 1) {
        window.location.href = '/pages/resultat-diagnostic';
        return;
      }
      
      // Sinon, déterminer le produit unique
      const concern = concerns[0];
      let handle = PRODUCT_MAP[concern];
      const symptomsForConcern = state.answers.symptoms_by_concern[concern] || [];
      if (symptomsForConcern.length > 0 && SYMPTOMS[concern]) {
        const symptomOptions = SYMPTOMS[concern].options;
        for (const symptomValue of symptomsForConcern) {
          const symptomOption = symptomOptions.find(opt => opt.value === symptomValue);
          if (symptomOption && symptomOption.product) {
            handle = symptomOption.product;
            break;
          }
        }
      }
      if (handle) window.location.href = `/products/${handle}`;
      return;
    }

    const qty = parseInt($('[data-qty-input]', app)?.value) || 1;
    const btns = $$('[data-add-to-cart], [data-sticky-add-to-cart]', app);
    btns.forEach(b => { b.disabled = true; b.textContent = 'Ajout en cours...'; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(r => { if (!r.ok) throw new Error(); return r.json(); })
    .then(() => {
      btns.forEach(b => {
        b.textContent = 'Ajouté !';
        b.style.background = '#4CC328';
      });
      setTimeout(() => { window.location.href = '/cart'; }, 1000);
    })
    .catch(() => {
      btns.forEach(b => { b.disabled = false; b.textContent = 'Ajouter au panier'; });
    });
  }

  /* ========== RESTART ========== */

  function restartQuiz() {
    state.currentStep = 0;
    state.answers = {
      pet_type: null, pet_name: null, pet_breed: null,
      age_value: 1, age_unit: 'years', birthdate: null,
      pet_weight: null,
      activity_level: null, medical_treatment: null,
      health_conditions: [], main_concerns: [],
      symptoms_by_concern: {}, symptoms: [],
      duration_by_concern: {}, duration: null, 
      email: null, first_name: null, phone: null
    };
    state.productData = null;

    // Reset calendrier
    calendarDate = new Date();
    calendarDate.setFullYear(calendarDate.getFullYear() - 3);

    $$('input[type="checkbox"]', app).forEach(cb => {
      cb.checked = false;
      cb.disabled = false;
    });
    $$('.quiz__option-card.is-selected', app).forEach(c => c.classList.remove('is-selected'));
    $$('.quiz__option-card--checkbox.is-selected', app).forEach(c => c.classList.remove('is-selected'));
    $$('.quiz__breed-tag.is-selected', app).forEach(c => c.classList.remove('is-selected'));
    $$('.quiz__breed-unknown.is-selected', app).forEach(c => c.classList.remove('is-selected'));
    $$('.quiz__weight-card.is-selected', app).forEach(c => c.classList.remove('is-selected'));
    
    // Reset counter
    const counter = $('[data-concerns-count]', app);
    if (counter) counter.textContent = '0 / 3 sélectionnées';
    
    const nameInput = $('[data-input="pet_name"]', app);
    if (nameInput) nameInput.value = '';
    
    const emailInput = $('[data-input="email"]', app);
    if (emailInput) emailInput.value = '';

    resultPage.style.display = 'none';
    container.style.display = '';
    renderStep();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ========== CONCERN CHECKBOXES ========== */

  function initConcernCheckboxes() {
    // Pour les labels qui wrappent des checkboxes, le browser gère déjà le toggle
    // On a juste besoin d'écouter le changement de state
    
    $$('input[name="main_concerns"]', app).forEach(cb => {
      cb.addEventListener('change', updateConcernsState);
    });
    
    // Aussi écouter les clics sur les cartes pour le feedback visuel immédiat
    $$('.quiz__option-card--checkbox', app).forEach(card => {
      card.addEventListener('click', (e) => {
        // Le browser a déjà toggle la checkbox via le label
        // On met juste à jour le state après un micro-délai
        setTimeout(() => updateConcernsState(), 10);
      });
    });
  }

  function updateConcernsState() {
    // Mettre à jour le state
    const checkedBoxes = $$('input[name="main_concerns"]:checked', app);
    state.answers.main_concerns = Array.from(checkedBoxes).map(cb => cb.value);
    
    // Limiter à 3 sélections
    const allBoxes = $$('input[name="main_concerns"]', app);
    if (state.answers.main_concerns.length >= 3) {
      allBoxes.forEach(cb => {
        if (!cb.checked) cb.disabled = true;
      });
    } else {
      allBoxes.forEach(cb => cb.disabled = false);
    }
    
    // Update counter
    const counter = $('[data-concerns-count]', app);
    if (counter) {
      counter.textContent = `${state.answers.main_concerns.length} / 3 sélectionnées`;
    }
    
    // Update visual state
    $$('.quiz__option-card--checkbox', app).forEach(card => {
      const cb = card.querySelector('input[type="checkbox"]');
      if (cb?.checked) {
        card.classList.add('is-selected');
      } else {
        card.classList.remove('is-selected');
      }
    });
    
    updateNavButtons();
  }

  /* ========== BOOT ========== */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();